import { ContentFlexComponent } from "components/flexComponents/Content/typings";
import * as React from "react";
import EditorialBase from "components/flexComponents/Content/factory/EditorialBase";
import { EditorialModel } from "typings/microserviceModels/content-flex-module";
import EditorialItemModel from "components/flexComponents/Content/factory/impl/items/EditorialItemModel";
import { UitkCard, UitkCardContent } from "uitk-react-cards";
import { UitkHeading } from "uitk-react-text";
import {
  PageBackgroundContext,
  BackgroundColorTokens,
} from "src/components/flexComponents/PageLevelProviders/PageBackgroundColor/PageBackgroundContext.tsx";

export class AffinityDescription extends EditorialBase {
  /* istanbul ignore next */
  public constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  /**
   * An Editorial consists of HTML strings that we parse through with the best of
   * our abilities and display as is on the page. Mainly, we do not control the
   * content of an Editorial, we simply put them in the page.
   */
  public generate() {
    return (
      <div
        className="uitk-grid uitk-cell"
        id={this.flexComponent.id}
        data-fm={this.flexComponent.fmId}
        data-fm-title-id={this.flexComponent.fmTitleId}
      >
        {this.editorial.items
          .filter((item: EditorialModel) => item.text && item.title)
          .map((item: EditorialModel) => {
            return this.getItem(new EditorialItemModel(item.id, item.text, item.title, this.editorial.uitkIconName));
          })}
      </div>
    );
  }

  public decorateAffinityDescriptionHtml(text: string = "") {
    const htmlWithStyle = text.replace(/<h3/gi, '$& class="uitk-type-regular uitk-type-600 all-b-margin-two"');

    return { __html: htmlWithStyle };
  }

  public getItem(model: EditorialItemModel): JSX.Element {
    const backgroundColor = React.useContext(PageBackgroundContext);
    const withBorder = backgroundColor === BackgroundColorTokens.BACKGROUND_WHITE;

    return (
      <UitkCard key={`${this.contentPurpose}-${this.keyHelper.next()}`} withBorder={withBorder}>
        <UitkCardContent>
          <div className="all-y-padding-three uitk-grid">
            <div className="uitk-cell s-cell-1-1 m-cell-2-3 l-cell-2-3 xl-cell-2-3">
              <div className="uitk-type-paragraph-300" data-fm-content={model.id} id={model.id}>
                {this.flexComponent.pageHeading && (
                  <div className="all-b-margin-one">
                    <UitkHeading level={1} size={800}>
                      {this.flexComponent.pageHeading}
                    </UitkHeading>
                  </div>
                )}
                {model.title && <h2 className="uitk-type-heading-600 uitk-type-regular">{model.title}</h2>}
                {model.text && (
                  <div
                    className="all-t-padding-two uitk-type-list-300"
                    dangerouslySetInnerHTML={this.decorateAffinityDescriptionHtml(model.text)}
                  />
                )}
              </div>
            </div>
          </div>
        </UitkCardContent>
      </UitkCard>
    );
  }
}

export default AffinityDescription;
